<div class="body-content">
  <div class="logo">
    <img alt="Company Logo"  src="assets/images/uw-logo-en.svg" />
  </div>
  <div class="box1"></div>
  <div class="box2"></div>
  <div class="box3"></div>
  <div class="box4"></div>
  <div class="main">
    <div class="sideimage"><img alt="Welcome Side Image" src="assets/images/Layer_1.png" /></div>
    <div class="login-side">
      <div class="auth-container">

        <form class="login-form" [formGroup]="forgotPasswordFormGrp">
          <div class="align-center">
            <h2>{{ "common.forgot_password" | translate }}</h2>
          </div>
          @if (errorMessage) {
            <div class="error-container" style="margin-bottom:10px" >
              {{this.errorMessage}}
            </div>
          }
          <span>{{ "common.dont_worry_weve_got_your_back!_just_enter_your_email_address_and_well_send_you_a_link_with_which_you_can_reset_your_password." | translate }}</span>
          <div class="row uw-field" style="margin-top:10px">
            <div class="col-sm-12 form-group">
              <label for="email" class="uw-label"   style="margin-bottom:10px">
                <span>{{ "common.email" | translate }}</span>
              </label>
              <input id="email" type="email" class="uw-input"  formControlName="email"  placeholder="">
              @if (forgotPasswordFormGrp.get('email')?.hasError('email') && !forgotPasswordFormGrp.get('email')?.hasError('required')) {
                <mat-error>
                  {{ "common.please_enter_a_valid_email_address" | translate }}
                </mat-error>
              }
            </div>
          </div>
          <div class="flex-column-center">
            <button  class="uw-default-button" [disabled]="!forgotPasswordFormGrp.valid" (click)="sendRequest()">{{"login.forgotPasssword_btn" | translate}}</button>
            <button style="margin-top:10px" mat-button [routerLink]="['/login']">{{"Return to Sign In" | translate}}?</button>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
